import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./mocks/mocks";
import "./styles/zinnes-theme.css";
import store from "./store/store";
import { bootstrapClientToken } from "./server/oauthService";

Vue.config.productionTip = false;

const GA_MEASUREMENT_ID = "G-VMKN52WXZE";
let hasTrackedInitialPageView = false;

router.afterEach((to) => {
  if (typeof window.gtag !== "function") {
    return;
  }

  if (!hasTrackedInitialPageView) {
    hasTrackedInitialPageView = true;
    return;
  }

  Vue.nextTick(() => {
    window.gtag("event", "page_view", {
      send_to: GA_MEASUREMENT_ID,
      page_path: to.fullPath,
      page_location: window.location.href,
      page_title: document.title,
    });
  });
});

// Obtém o token OAuth de cliente antes de montar a app.
// Em caso de falha, a app monta mesmo assim (degradação graciosa) —
// as rotas públicas retornarão 401 até que o token seja obtido.
bootstrapClientToken()
  .catch((err) => console.error("[OAuth] bootstrap falhou:", err))
  .finally(() => {
    new Vue({
      router,
      vuetify,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  });
